import useAppHooks from "../../../../../../shared/hooks/useAppHooks";
import { useLocation } from "react-router-dom";
import { getExamSectionKey } from "../../../../../../shared/utilities/helpers/examSectionKey";
import {
  fetchExamQuestionRequest,
  setCurrentQuestionIndex,
  setActiveSection,
} from "../../../../../../redux/exam/examSlice";
import { normalizeExamQuestionStatus } from "../../../../../../shared/utilities/helpers/examQuestionStatus";
import "./QuestionGrid.css";

export default function QuestionGrid({
  onSelect,
  registerRef,
  showSectionTitles = true,
  maxQuestions,
}) {
  const { dispatch, selector } = useAppHooks();
  const location = useLocation();
  const { questionsData, testDetails, paperId, testType } = selector(
    (s) => s.examSlice
  );
  const isAdaptiveMode = location?.state?.useAdaptiveTestScreen === true;
  const adaptiveQuestionId =
    location?.state?.adaptive_question_id ??
    location?.state?.adaptiveQuestionId ??
    null;
  const adaptivePaperType = Number(location?.state?.paper_type ?? 20);

  /* --------------------------------
     GROUP QUESTIONS BY SECTION
  -------------------------------- */
  const grouped = [];
  const map = {};

  const limitedQuestions = Number.isFinite(maxQuestions)
    ? questionsData.slice(0, Math.max(0, maxQuestions))
    : questionsData;

  limitedQuestions.forEach((q) => {
    const key = getExamSectionKey(q);
    if (!map[key]) map[key] = [];
    map[key].push(q);
  });

  for (const key in map) {
    grouped.push({ section: key, questions: map[key] });
  }

  /* --------------------------------
     STATUS → CSS CLASS
  -------------------------------- */
  const getClassByStatus = (question) => {
    const status = normalizeExamQuestionStatus(question);
    switch (status) {
      case "answered":
        return "question-box answered";
      case "unanswered":
        return "question-box unanswered";
      case "marked":
        return "question-box marked";
      case "answered_marked":
        return "question-box answered-marked";
      case "current":
        return "question-box current";
      default:
        return "question-box not-visited";
    }
  };

  return (
    <div>
      {grouped.map((group, groupIdx) => (
        <div key={groupIdx} className="question-section">
          {showSectionTitles ? (
            <h6 className="question-section-title">{group.section}</h6>
          ) : null}

          <div className="question-grid">
            {group.questions.map((q, idx) => {
             
              const globalIndex = limitedQuestions.findIndex(
                (ques) => ques.qid === q.qid
              );

              return (
                <div
                  key={q.qid}
                  ref={(el) => {
                    if (idx === 0 && registerRef) {
                      registerRef(group.section, el);
                    }
                  }}
                  className={getClassByStatus(q)}
                  onClick={() => {
                    if (typeof onSelect === "function") {
                      onSelect(q.qid);
                      return;
                    }

                    dispatch(setActiveSection(group.section));
                    dispatch(setCurrentQuestionIndex(globalIndex));

                    dispatch(
                      fetchExamQuestionRequest({
                        paperId: q?.paper_id ?? paperId,
                        paperType: isAdaptiveMode
                          ? adaptivePaperType
                          : testDetails?.paper_type || testType?.id,
                        adaptive_question_id: isAdaptiveMode
                          ? adaptiveQuestionId
                          : undefined,
                        qid: q.qid,
                        testId: testDetails?.testId,
                      })
                    );
                  }}
                >
                  
                  {globalIndex + 1}
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}
